<section *ngIf="this.loadingService.loading$ | async">
  <div class="d-flex justify-content-center container-loanding">
    <div class="spinner-border" role="status">
      <span class="sr-only"></span>
    </div>
  </div>
</section>